import DataSource from './DataSource';
import DataModel from './DataModel';

const DataAttributes = ['id', 'name', 'email', 'password', 'password_confirmation'];
const Defaults = {
  id: '',
  name: '',
  email: '',
  password: '',
  password_confirmation: '',
};

export default class User extends DataModel {
  static Defaults = Defaults;
  static DataAttributes = DataAttributes;
  static resource = DataSource.getSource('users', 'users{/:id}.json', 'user');

  constructor(data) {
    super(data);
    this.updateFrom({...this.constructor.Defaults, ...data});
  }

}

